import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=4e0e5e7b&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=4e0e5e7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e5e7b",
  null
  
)

export default component.exports